/**
 * Created by Administrator on 2017/9/19.
 */
import {msg} from './config.js';
import {CommonUtil} from './CommonUtil.js';
import {checkIdCard} from './idcard.js';


var validateUtil = {
  validate: function (rules, value) {
      let result = null;
    if (rules != null && rules != undefined) {
      for (let i = 0; i < rules.length; i++) {
         result = validateRule(rules[i], value);
        if (result != null) {
          break;
        }
      }
    }
    return result;
  },
  /**
   * 验证参数
   * @param validate 验证规则配置对象,例如{frameCode:[{name:'required',msg:''}],layerNumber:[{name:'required',msg:''}}
   * @param arr 需要验证的参数数组,例如[{name:"frameCode",value:"A1",domEle:该参数对应的dom元素对象},...]
   * @param showMsg 是否显示错误提示(不传则默认会显示,只有为false时不会显示,直接获取焦点)
   * @param timeout 错误信息提示时长
   * @returns {boolean}
   */
  validateParams: function (validate, arr, showMsg, timeout) {
    var isTrue = true;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].domEle === undefined || arr[i].domEle === null || arr[i].domEle.disabled) {
        //忽略被禁用元素
        continue;
      } else {
        var paramMsg = this.validate(validate[arr[i].name], arr[i].value);
        if (paramMsg != null) {
          if (showMsg != undefined && showMsg != null && showMsg == false) {
            arr[i].domEle.focus();
            arr[i].domEle.setSelectionRange(0, arr[i].domEle.value.length);
          } else {
            if (timeout == null || timeout == undefined || timeout < 0) {
              arr[i].domEle.showError(paramMsg, true);
            } else {
              arr[i].domEle.showError(paramMsg, true, timeout);
            }
          }
          isTrue = false;
          break;
        }
      }
    }
    return isTrue;
  }
}

function validateRule(rule, value) {
  switch (rule.name) {
    case 'required':
      return validateRequired(rule, value);
    case 'requiredStoreroom':
      return validateStoreroom(rule, value);
    case 'number':
      return validateNumber(rule, value);
    case 'validateNumberOrLetterOr':
      return validateNumberOrLetterOr(rule, value);
    case 'money':
      return validateMoney(rule, value);
    case 'maxMoney':
      return validateMaxMoney(rule, value);
    case 'minMoney':
      return validateMinMoney(rule, value);
    case 'idCard':
      return validateIdCard(rule, value);
    case 'year':
      return validateYear(rule, value);
    case 'month':
      return validateMonth(rule, value);
    case 'phone':
      return validatePhone(rule, value);
    case 'numberOrLetter':
      return validateNumberOrLetter(rule, value);
    case 'minLen':
      return validateMinLen(rule, value);
    case 'minNumber':
      return validateMinNumber(rule, value);
    case 'date':
      return validateDate(rule, value);
    case 'numberOrLetterOrChinese':
      return validateNumberOrLetterOrChinese(rule, value);
    case 'hallCodeAndBarNumber':
      return validateHallCodeAndBarNumber(rule, value);
    case 'hallCodeBarNumber':
      return validateHallCodeBarNumber(rule, value);
    case 'circulateCode':
      return validateCirculateCode(rule, value);
    case 'borrowCode':
      return validateBorrowCode(rule, value);
    case 'returnCode':
      return validateReturnCode(rule, value);
    case 'circulateCodeOrBorrowCode':
      return validateCirculateCodeOrBorrowCode(rule, value);
    case 'circulateCodeOrReturnCode':
      return validateCirculateCodeOrReturnCode(rule, value);
    case 'hallCode':
      return validateHallCode(rule, value);
    case 'irikuraCode':
      return validateIrikuraCode(rule, value);
    case 'PDCode':
      return validatePDCode(rule, value);//盘亏
    case 'TJCode':
      return validateTJCode(rule, value);//剔旧
    case 'warehouseFrameCode':
      return validateWarehouseFrameCode(rule, value);
    case 'frameCode':
      return validateFrameCode(rule, value);
    case 'isbn':
      return validateIsbn(rule, value);
    case 'borrowCard':
      return validateBorrowCard(rule, value);
    case 'chineseClassificationNumber':
      return validateChineseClassificationNumber(rule, value);
    case 'JSCodeOrHSCode':
      return validateJSCodeOrHSCode(rule, value);
    case 'catalogueUserName':
      return validateCatalogueUserName(rule, value);
    default:
      return null;
  }
}

/**
 * 非空验证
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateRequired(rule, value) {
  if (value === null || value === '') {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(输入不能为空)
      return msg.emptyInput;
    } else {
      return rule.msg;
    }
  } else {
    return null;
  }
}

function validateStoreroom(rule, value) {
  if (value === null || value === '') {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(输入不能为空)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  } else {
    return null;
  }
}

function validateIdCard(rule, value) {
//   var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value === null || value === '' ||!checkIdCard(value)) {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
        return msg.idCardError;
      }
      return rule.msg;
}else{
    return null; 

}
}
//   if (value === null || value === '' || checkIdCard(value)) {
//     return null;
//   } else {
//     if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
//       return msg.idCardError;
//     } else {
//       return rule.msg;
//     }
//   }
// }

/**
 * 纯数字验证(可为空)
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateNumber(rule, value) {
  if (value === null || value === '' || /^[0-9]*$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 金额验证(可为空)
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateMoney(rule, value) {
  if (value === null || value === '' || /^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 最大金额验证(可为空)
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateMaxMoney(rule, value) {
  if (value === null || value === '' || /^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
    if (/^[0-9]+(.[0-9]{1,2})?$/.test(value) && parseFloat(value) > 999999.00) {
      return msg.limitationValue;
    } else {
      return null;
    }
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 最小金额验证(可为空)
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateMinMoney(rule, value) {
  if (value === null || value === '' || (/^[0-9]+(.[0-9]{1,2})?$/.test(value) && parseFloat(value) > 0)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 验证年份(首位不能为0且只能为4位数字,可为空)
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateYear(rule, value) {
  if (value === null || value === '' || /^[1-9][0-9]{3}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 验证月份(只能1-12或01-12,可为空)
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateMonth(rule, value) {
  if (value === null || value === '' || /^[1-9]$/.test(value) || /^(1[0,1,2]{1})|(0[1-9])$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 验证手机号码(可为空)
 * @param rule
 * @param value
 * @returns {*}
 */
function validatePhone(rule, value) {
  if (value === null || value === '' || /^1[3|4|5|8|7][0-9]{9}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.phoneError;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 字母或数字验证
 * @param rule
 * @param value
 * @returns {*错误信息}
 */
function validateNumberOrLetter(rule, value) {
  if (value === null || value === '' || /^[0-9a-zA-Z]+$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(密码错误)
      return msg.getMsgByCode(1003);
    } else {
      return rule.msg;
    }
  }
}

/**
 * 校验最小长度
 * @param rule 例如:{name:'minLen',len:10,msg:'错误值'}
 * @param value
 */
function validateMinLen(rule, value) {
  if (value === null || value.length < rule.len) {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(密码错误)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  } else {
    return null;
  }
}

/**
 * 验证整数最小值
 * @param rule
 * @param value 例如:{name:'minNumber',min:1,msg:'错误值'}
 * @returns {*}
 */
function validateMinNumber(rule, value) {
  if (value === null || value === '' || (validateNumber(rule, value) == null && parseInt(value) >= rule.min)) {
    return null;
  } else {
    if (rule.msg == null) {
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 校验排架号格式,只能由数字,大写字母,汉字组成,最大字节长度为6
 * @param rule
 * @param value
 * @returns {*}
 */
function validateWarehouseFrameCode(rule, value) {
  value = value.toUpperCase();
  if (value === null || value === '' || (/^[0-9A-Z\u4e00-\u9fa5]+$/.test(value) && CommonUtil.getByteLength(value) <= 6)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(排架号错误!)
      return msg.frameCodeError;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 验证排架格子号格式(排架号溢架号-溢架号下第几架格子号)
 * @param rule
 * @param value
 * @returns {*}
 */
function validateFrameCode(rule, value) {
  if (value === null || value === '' || /^[0-9A-Z\u4e00-\u9fa5]+([a-z]{0,1}-[0-9]{0,2}){0,1}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(排架号错误!)
      return msg.frameCodeError;
    } else {
      return rule.msg;
    }
  }
}

function validateBorrowCard(rule, value) {
  if (value) {
    if (value.length === 11 || value.length === 18) {
      return '';
    }
  }
}

function validateIsbn(rule, value) {
  if (value === null || value === '' || /^[0-9]{13}$/.test(value) || /^[0-9]{9}[0-9X]{1}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值!)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 验证日期字符串
 * @param rule
 * @param value
 * @returns {*}
 */
function validateDate(rule, value) {
  if (CommonUtil.isDate(value) == null) {
    if (rule.msg == null) {
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  } else {
    return null;
  }
}

/**
 * 验证只能有字母数字汉字组成的格式
 * @param rule
 * @param value
 */
function validateNumberOrLetterOrChinese(rule, value) {
  if (value === null || value === '' || /^[0-9a-zA-Z\u4e00-\u9fa5]+$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

//必须包含数字大小写字母
function validateNumberOrLetterOr(rule, value) {
  if (value.length < 8) {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  } else if (/[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}


function validateHallCodeAndBarNumber(rule, value) {
  if (value === null || value === '' || /[A-Z]{4,5}[0-9]{1,7}$/.test(value) || /^[0-9]{1,7}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.barNumberError;
    } else {
      return rule.msg;
    }
  }
}

function validateHallCodeBarNumber(rule, value) {
  if (value === null || value === '' || /[A-Z]{4,5}[0-9]{1,7}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.barNumberError;
    } else {
      return rule.msg;
    }
  }
}

/**
 * 验证中图分类法的分类号格式
 * @param rule
 * @param value
 * @returns {*}
 */
function validateChineseClassificationNumber(rule, value) {
  if (value === null || value === '' || /[A-Z]{1}[0-9]{0,3}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.frameCodeError;
    } else {
      return rule.msg;
    }
  }
}

function validateCirculateCode(rule, value) {
  if (value === null || value === '' || /LT[0-9]{1,8}$/.test(value) || /^[0-9]{1,8}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}
//入藏
function validateIrikuraCode(rule, value) {
  if (value === null || value === '' || /BM[0-9]{1,8}$/.test(value) || /^[0-9]{1,8}$/.test(value)) {
    return null;

  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

//盘亏
function validatePDCode(rule, value) {
  if (value === null || value === '' || /PD[0-9]{1,8}$/.test(value) || /^[0-9]{1,8}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

//剔旧
function validateTJCode(rule, value) {
  if (value === null || value === '' || /TJ[0-9]{1,8}$/.test(value) || /^[0-9]{1,8}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}


function validateBorrowCode(rule, value) {
  if (value === null || value === '' || /JS[0-9]{1,8}$/.test(value) || /^[0-9]{1,8}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

function validateReturnCode(rule, value) {
  if (value === null || value === '' || /HS[0-9]{1,8}$/.test(value) || /^[0-9]{1,8}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

function validateCatalogueUserName(rule, value) {
  var config = ['编目1', '编目2', '编目3', '编目4', '编目5', '编目6', '编目7', '编目8', '编目9', '编目10'];
  if (value === null || value === '' || !CommonUtil.contains(config, value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.usernameRepetition;
    } else {
      return rule.msg;
    }
  }
}

function validateCirculateCodeOrBorrowCode(rule, value) {
  if (validateCirculateCode(rule, value) == null || validateBorrowCode(rule, value) == null) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

function validateCirculateCodeOrReturnCode(rule, value) {
  if (validateCirculateCode(rule, value) == null || validateReturnCode(rule, value) == null) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}


function validateJSCodeOrHSCode(rule, value) {
  if (validateBorrowCode(rule, value) == null || validateReturnCode(rule, value) == null) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}

function validateHallCode(rule, value) {
  if (value === null || value === '' || /[A-Z]{4,5}$/.test(value)) {
    return null;
  } else {
    if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
      return msg.errorValue;
    } else {
      return rule.msg;
    }
  }
}
export {validateUtil};
